export const allowedAppIds = ['23', '26', '28', '29', '31', '32', '33', '36', '37', '47']
export const isStaging = import.meta.env.VITE_SERVER_ENV === 'staging'
